export default "{\n    \"postalCode\": \"Postcode\"\n}\n"